import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { DataTableComponent } from '../../../../../components/ui/data-table/data-table.component';
import { StatusComponent } from '../../../../../components/ui/status/status.component';
import { EmptyStateComponent } from '../../../../../components/ui/empty-state/empty-state.component';
import { IMessageReportContacts } from '../../../campaigns/types/messagesTypes';
import { ReceiptView, toReceiptViews } from '../report-shared';

/**
 * One page of a send's delivery receipts. Paging, search and filters live
 * on the report page; this table only draws the rows it is given.
 */
@Component({
  selector: 'app-message-reports-table',
  standalone: true,
  imports: [DataTableComponent, StatusComponent, EmptyStateComponent],
  templateUrl: './message-report-table.component.html',
  styleUrl: './message-report-table.component.css',
})
export class MessageReportTableComponent implements OnChanges {
  @Input() data: IMessageReportContacts[] = []; // Pass data from parent
  @Input() status_list: any[] = []; // Pass data from parent
  @Input() loading: boolean = false;
  @Input() meta: any;
  @Input() startItem: number = 0;
  @Input() endItem: number = 0;
  /** Live search term, so the empty state can say nothing matches it. */
  @Input() query: string = '';
  /** True when a delivery filter narrows the list. */
  @Input() filtered: boolean = false;
  /** Empty-state line when nothing is filtered or searched. */
  @Input() emptyMessage: string = 'No delivery receipts yet.';
  @Input() emptyHint: string = '';
  /** Shown in place of the built-in advice while a search or filter is on (e.g. a load error). */
  @Input() filteredHint: string = '';
  /** Clears the search and filter from the empty state. */
  @Output() clear = new EventEmitter<void>();

  rows: ReceiptView[] = [];

  ngOnChanges() {
    this.rows = toReceiptViews(this.data);
  }
}
